import { Box, Card, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { ReactComponent as FinanceIcon } from "../../assets/svg/project/finance.svg";
import { useProject } from "../../contexts/project.context";
import { VerticalTab } from "../VerticalTabs";
import ProjectSummary from "./templates/ProjectSummary";

const SummaryStep = () => {
  const { loadingProject } = useProject();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const projectId = searchParams.get("projectId");
  const [optionActive, setOptionActive] = useState(0);
  const [showUpdateStatus, setShowUpdateStatus] = useState(false);

  const options = [
    {
      title: "Resumo financeiro",
      description: "",
      icon: <FinanceIcon />,
      template: <ProjectSummary onNext={() => setOptionActive(1)} />,
    },
  ];

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      pt={2}
      pb={4}
      bgcolor={"#F9FCFF"}
      flex={1}
      width={"100%"}
      overflow="auto"
    >
      {loadingProject && (
        <Box
          display={"flex"}
          width={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={2}
          py={10}
          mt={10}
        >
          <Typography variant={"h6"}>Carregando...</Typography>
          <CircularProgress />
        </Box>
      )}

      <Card
        sx={{
          display: "flex",
          mt: 1,
          mx: 5,
          boxShadow: "0px 4px 18px 0px #4B465C1A",
          maxWidth: 1480,
        }}
      >
        {!loadingProject && (
          <>
            <VerticalTab.Root>
              {options.map(({ title, description, icon }, index) => (
                <VerticalTab.Item
                  key={index}
                  onClick={() => setOptionActive(index)}
                >
                  <VerticalTab.Icon
                    icon={icon}
                    isActive={optionActive === index}
                  />
                  <VerticalTab.Content
                    title={title}
                    description={description}
                  />
                </VerticalTab.Item>
              ))}
            </VerticalTab.Root>

            {options[optionActive] && options[optionActive].template}
          </>
        )}
      </Card>
    </Box>
  );
};

export default SummaryStep;
